import { API, arrayQueryParamsSerializer } from './resources'

export default {
  getAll: (limit, offset, query, sort, exclude, filter, currentPage) => {
    return API.get('/projects', {
      params: { limit, offset, query, sort, exclude, filter, currentPage },
      paramsSerializer: arrayQueryParamsSerializer
    })
  },
  create: (data) => {
    return API.post('/projects', data)
  },
  get: (id) => {
    return API.get(`/projects/${id}`)
  },
  getTemplateForProject: (id) => {
    return API.get(`/projects/${id}/template`)
  },
  getByArticleID: (id) => {
    return API.get(`/projects/articles/${id}`)
  },
  update: (id, data) => {
    return API.put(`/projects/${id}`, data)
  },
  updateCategories: (id, categories) => {
    return API.put(`/projects/${id}/categories`, { categories })
  },
  updatePrivate: (id, isPrivate) => {
    return API.post(`/projects/${id}/private`, { isPrivate })
  },
  updatePinned: (id, categoryID, isPinned) => {
    return API.post(`/projects/${id}/pinned`, { categoryID, isPinned })
  },
  updateHidden: (id, isHidden) => {
    return API.put(`/projects/${id}/hidden`, { isHidden })
  },
  updateSubmitted: (id, submitted) => {
    return API.put(`/projects/${id}/submitted`, { submitted })
  },
  updateBlueRibbon: (id, blueRibbon) => {
    return API.put(`/projects/${id}/blueribbon`, { blueRibbon })
  },
  updateIsTemplate: (id, isTemplate) => {
    return API.put(`/projects/${id}/isTemplate`, { isTemplate })
  },
  updateCustomPostOrder: (id, customPostOrder) => {
    return API.put(`/projects/${id}/customPostOrder`, { customPostOrder })
  },
  updateProjectIsOnline: (id, isOnline) => {
    return API.put(`/projects/${id}/updateProjectIsOnline`, { isOnline })
  },
  delete: (id) => {
    return API.delete(`/projects/${id}`)
  },
  getComments: (id, limit, offset, before, since) => {
    return API.get(`/projects/${id}/comments`, { params: { limit, offset, before, since } })
  },
  createComment: (id, body, anonymous, attachments) => {
    return API.post(`/projects/${id}/comments`, { body, anonymous, attachments })
  },
  createReply: (id, body, anonymous, attachments, parentID) => {
    return API.post(`/projects/${id}/comments/${parentID}/replies`, { body, anonymous, attachments })
  },
  addTags: (id, data) => {
    return API.post(`/projects/${id}/tags`, data)
  },
  setTags: (id, data) => {
    return API.put(`/projects/${id}/tags`, data)
  },
  getByTag: (tag, limit, offset, sort, filter, exclude, showHidden, type, includeAllPartners) => {
    return API.get(`/projects/tags/${tag}`, { params: { limit, offset, sort, filter, exclude, showHidden, type, includeAllPartners } })
  },
  getByTemplateID: (templateID, limit, offset, sort, filter, exclude, showHidden, type, IncludeIsefCareerHallInventors, ExcludeIsefCareerHallInventors, alphabets, lastNames) => {
    return API.get(`/projects/templateids/${templateID}`, { params: { limit, offset, sort, filter, exclude, showHidden, type, IncludeIsefCareerHallInventors, ExcludeIsefCareerHallInventors, alphabets, lastNames } })
  },
  getByTemplateIDs: (templateIDs, limit, offset, sort, filter, exclude, showHidden, type, IncludeIsefCareerHallInventors) => {
    return API.get('/projects/templateids/dropdown', { params: { templateIDs, limit, offset, sort, filter, exclude, showHidden, type, IncludeIsefCareerHallInventors } })
  },
  getTemplateForDiscover: (exploreUrl) => {
    return API.get('/projects/discover/template', { params: { exploreUrl } })
  },
  getByYear: (year, limit, offset, sort, filter, exclude, showHidden, platform, type) => {
    return API.get(`/projects/year/${year}`, { params: { limit, offset, sort, filter, exclude, showHidden, platform, type } })
  },
  getByPhase: (phase, limit, offset) => {
    return API.get(`/projects/phase/${phase}`, { params: { limit, offset } })
  },
  getSubscribers: (id, limit, offset) => {
    return API.get(`/projects/${id}/subscribers`, { params: { id, limit, offset } })
  },
  isSubscribed: (id, username) => {
    return API.get(`/projects/${id}/subscribers/${username}`)
  },
  subscribe: (id) => {
    return API.post(`/projects/${id}/subscribers`)
  },
  unsubscribe: (id) => {
    return API.delete(`/projects/${id}/subscribers`)
  },
  getLikes: (id, limit, offset) => {
    return API.get(`/projects/${id}/likes`, { params: { limit, offset } })
  },
  hasLiked: (id, username) => {
    return API.get(`/projects/${id}/like/${username}`)
  },
  like: (id) => {
    return API.post(`/projects/${id}/like`)
  },
  unlike: (id) => {
    return API.delete(`/projects/${id}/like`)
  },
  logBoard: (id, data) => {
    return API.post(`/projects/${id}/log`, data)
  },
  getMembers: (id, limit, offset) => {
    return API.get(`/projects/${id}/members`, { params: { limit, offset } })
  },
  isMember: (id, username) => {
    return API.get(`/projects/${id}/members/${username}`)
  },
  addMember: (id, data) => {
    return API.put(`/projects/${id}/members`, data)
  },
  updateMember: (id, username, data) => {
    return API.put(`/projects/${id}/members/${username}`, data)
  },
  inviteMember: (id, data) => {
    return API.post(`/projects/${id}/members`, data)
  },
  acceptInvite: (id, username) => {
    return API.post(`/projects/${id}/members/${username}`)
  },
  join: (id) => {
    return API.put(`/projects/${id}/members`)
  },
  leave: (id, username) => {
    return API.delete(`/projects/${id}/members/${username}`)
  },
  getUploads: (id, type, limit, page) => {
    return API.get(`/projects/${id}/board/uploads/${type}`, { params: { limit, page } })
  },
  createLink: (parentID, childID) => {
    return API.post(`/projects/${parentID}/links/${childID}`)
  },
  deleteLink: (parentID, childID) => {
    return API.delete(`/projects/${parentID}/links/${childID}`)
  },
  getLinks: (parentID) => {
    return API.get(`/projects/${parentID}/links`)
  },
  getFeaturedProjects: (limit, offset, sort, filter, currentPage) => {
    return API.get('/projects/featured', { params: { limit, offset, sort, filter, currentPage } })
  },
  getFeaturedProjectsCount: () => {
    return API.get('/projects/featured/count')
  },
  getAwardedProjects: (limit, offset, sort, filter) => {
    return API.get('/projects/awarded', { params: { limit, offset, sort, filter } })
  },
  getPremiumProjects: (limit, offset, sort, filter) => {
    return API.get('/projects/premium', { params: { limit, offset, sort, filter } })
  },
  copy: (id, data) => {
    return API.post(`/projects/${id}/copy`, data)
  },
  copyPost: (destProjectID, postID, data) => {
    return API.post(`/projects/${destProjectID}/copyPost/${postID}`, data)
  },
  getRecommended: (limit, offset, query, sort, filter, exclude) => {
    return API.get('/projects/recommended', { params: { limit, offset, query, sort, filter, exclude } })
  },
  getRecommendedForProject: (id, type, limit, filter) => {
    return API.get(`/projects/${id}/recommended`, { params: { type, limit, filter } })
  },
  getSimilar: (id, limit, page) => {
    return API.get(`/projects/${id}/similar`, { params: { limit, page } })
  },
  getPopular: (limit, offset, query, filter, sort, exclude) => {
    return API.get('/projects/popular', { params: { limit, offset, query, filter, sort, exclude }, paramsSerializer: arrayQueryParamsSerializer })
  },
  getPopularByCategory: (data) => {
    return API.post('/projects/popular/categories', data)
  },
  getCategories: (page = 'home') => {
    return API.get('/projects/categories', { params: { all: true, page: page } })
  },
  getByCategory: (category, limit, offset, sort, filter, exclude, pinned, iterator, filterTags) => {
    return API.get(`/projects/category/${category}`, { params: { limit, offset, sort, filter, exclude, pinned, iterator, filterTags }, paramsSerializer: arrayQueryParamsSerializer })
  },
  suggestCategories: (id) => {
    return API.get(`/projects/${id}/categories/suggest`)
  },
  createStory: (story) => {
    return API.post('/projects/story', story)
  },
  updateStory: (id, story) => {
    return API.put(`/projects/${id}/story`, story)
  },
  searchInProject: (id, searchQuery) => {
    return API.post(`/projects/${id}/search`, { searchQuery })
  },
  saveCategorySponsors: (id, data) => {
    return API.put(`/projects/category/${id}/update`, data)
  },
  getByAward: (awardID, limit, offset, sort, filterTags) => {
    return API.get('/projects/award', { params: { awardID, limit, offset, sort, filterTags } })
  },
  getAllYscAwardProjects: (limit, offset, sort) => {
    return API.get('/projects/award/allYsc', { params: { limit, offset, sort } })
  },
  getYsc2021AwardProjects: (limit, offset, sort) => {
    return API.get('/projects/award/2021', { params: { limit, offset, sort } })
  },
  getYsc2022GrandProjects: (limit, offset, sort) => {
    return API.get('/projects/award/2022', { params: { limit, offset, sort } })
  },
  getYscChallengeAwardProjects: (limit, offset, sort) => {
    return API.get('/projects/award/challenge', { params: { limit, offset, sort } })
  },
  getResourceByType: (limit, offset, sort, filter, query, iterator) => {
    return API.get('/projects/resources', { params: { limit, offset, sort, filter, query, iterator } })
  },
  getTemplateCustomerQuestions: (templateID, excludeAnswered, context) => {
    return API.get(`/project/template/${templateID}/questions`, { params: { excludeAnswered, context } })
  },
  getDeclineReasons: () => {
    return API.get('/projects/status/messages')
  },
  enterDeclineReason: (projectID, messageID) => {
    return API.get('/projects/status/messages/enter', { params: { projectID, messageID } })
  },
  enterDeclineComment: (projectID, messageBody) => {
    return API.get('/projects/status/messages/custom', { params: { projectID, messageBody } })
  },
  getProjectStatus: (projectID) => {
    return API.get('/projects/status', { params: { projectID } })
  },
  updateProjectStatus: (id, statusToAdd, statusToRemove) => {
    return API.get('/projects/status/clearandadd', { params: { id, statusToAdd, statusToRemove } })
  },
  approveOrDeclineProject: (projectID, status, reason) => {
    return API.get('/projects/status/approveordecline', { params: { projectID, status, reason } })
  },
  getSubmissionsForPartner: (data) => {
    return API.post('/status/partner/projects', data)
  },
  getFairID: (projectID) => {
    return API.get(`/project/${projectID}/fairID`)
  },
  getRegionForProject: (projectID) => {
    return API.get(`/project/${projectID}/region`)
  },
  getByRegion: (regionID, limit, offset, sort, filter) => {
    return API.get(`/region/${regionID}/projects`, { params: { limit, offset, sort, filter } })
  },
  trackContentView: (boardID, name, utmSource) => {
    return API.post(`/contentView/log/${boardID}`, { name, utmSource })
  },
  getCertificateForProject: (projectID) => {
    return API.get(`/project/${projectID}/certificate`)
  },
  updateTemplateSettings: (id, data) => {
    return API.post(`/projects/${id}/updatetemplatesettings`, data)
  },
  updateProjectFlags: (id, isHidden, isEditable, submitted, isPrivate) => {
    return API.post(`/project/${id}/update/flags`, { isHidden, isEditable, submitted, isPrivate })
  },
  bulkInviteToProject: (id, emails) => {
    return API.post(`/projects/${id}/bulkinvite`, { emails })
  },
  getCategoriesByEvent: (eventSlug) => {
    return API.get(`/projects/categories/${eventSlug}`)
  },
  addProjectStatus: (projectID, status) => {
    return API.get(`/projects/status/add?projectID=${projectID}&Add=${status}`)
  },
  removeProjectStatus: (projectID, status) => {
    return API.get(`/projects/status/remove?projectID=${projectID}&Remove=${status}`)
  },
  getProjectTagsByTemplateIDs: (templateIDs) => {
    return API.get(`/projects/tags?templateIDs=${templateIDs.join(',')}`)
  },
  linkProjectsByTag: (teamID, tagGroups, templateIDs, limit, excludeLinkedProjects, replaceAll) => {
    return API.post('/projects/linkbytags', { projectID: teamID, tagGroups: tagGroups, templateIDs: templateIDs, limit: limit, excludeLinkedProjects: excludeLinkedProjects, replaceAll: replaceAll })
  },
  unlinkAll: (teamID) => {
    return API.post('/projects/unlinkall', { projectID: teamID })
  },
  getProjectsByGroupCode: (groupCode, limit, offset, sort, filter) => {
    return API.get(`/projects/group/${groupCode}`, { params: { limit, offset, sort, filter } })
  }
}
